import React, { useState } from "react"
import { injectIntl } from "gatsby-plugin-intl"


const Alert = ({ name, body, title, button, intl }) => {
  const [accepted, setAccepted] = useState(false)

  const acceptAlert = () => {
    typeof window !== "undefined" && window.localStorage.setItem(name, "ok")
    setAccepted(true)
  }

  const isAlertAccepted = () => {
    return typeof window !== "undefined" && window.localStorage.getItem(name) === "ok"
  }

  const isItaliano = () => {
    return intl.locale === 'it'
  }

  if (isItaliano()) {
    return !isAlertAccepted() && !accepted ? (
      <>
        <div className="c-alert__background" />
        <div className="c-alert">
          <div className="c-alert__container">
            <h4>{title}</h4>
            <div className="c-alert__info">
              {body}
            </div>
            <button className="a-btn a-btn--primary" onClick={acceptAlert} >
              {button}
            </button>
          </div>
        </div>
      </>
    ) : null
  } else return null
}

export default injectIntl(Alert)